import { render } from "./AdminReviews.vue?vue&type=template&id=3fb299eb"
import script from "./AdminReviews.vue?vue&type=script&lang=js"
export * from "./AdminReviews.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__